import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/ClientProviders.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
